import type { SetRequired } from 'type-fest';

import type { GroupObject, MemberEntity, ReferenceObjectWithPermissionsGroupsItem } from '@/modules/api/codegen';

export type Group = SetRequired<GroupObject, 'id'>;

export type GroupWithPermissions = SetRequired<ReferenceObjectWithPermissionsGroupsItem, 'id' | 'accessPermissions'>;

export interface GroupWithUsedCount extends Group {
    usedCount: number;
}

export type GroupById = {
    [key: Group['id']]: Group;
};

export type GroupMember = Required<MemberEntity>;

export type GroupMemberById = {
    [key: GroupMember['id']]: GroupMember;
};

export enum EntityKey {
    GROUPS = 'groups',
    GROUP_MEMBERS = 'groupMembers',
}
